import React, { useEffect, useRef, useState } from "react";
import "./EditableTask.scss";
import Button from "../Button/Button";
import { Task_Inputs } from "./TodoConstants";
import { FormInputSectionComponent } from "../FormInputSectionComponent/FormInputSectionComponent";
import { useDispatch } from "react-redux";
import { updateValueForm } from "../FormInputSectionComponent/formUtils";

function EditableTask({
  _id,
  Title,
  Notes,
  Due_Date = null,
  Priority,
  assignees,
  Assignee,
  Is_Completed,
  Is_Expanded,
  onFieldUpdate,
  onToggleExpand,
  onDelete,
  onSave,
  deleteLoading,
  updateLoading,
  Form_Key,
  task,
}) {
  const [taskDetails, setTaskDetails] = useState({
    Title,
    Notes,
    Due_Date,
    Priority,
    Assignee,
    Is_Completed,
  });

  const formRef = useRef({});
  const [FormData, setFormdata] = useState({});
  const dispatch = useDispatch();
  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };
  const handleInputChange = (field, value, assigneeId = null) => {
    setTaskDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
    onFieldUpdate(_id, field, value);
  };

  const handleSave = () => {
    console.log(taskDetails);
    onSave(_id, taskDetails);
  };

  const today = new Date().toISOString().split("T")[0];
  const setToday = () => handleInputChange("Due_Date", today);
  const setTomorrow = () => {
    const tomorrow = new Date(Date.now() + 86400000).toISOString().split("T")[0];
    handleInputChange("Due_Date", tomorrow);
  };

  const isOverdue =
    taskDetails.Due_Date && new Date(taskDetails.Due_Date) < new Date(today) && !taskDetails.Is_Completed;

  const assigneeName = task?.Assignee?.UserName ? task?.Assignee?.UserName : "No assignee";

  useEffect(() => {
    setTaskDetails({ ...taskDetails, ...FormData });
  }, [Title, Notes, Due_Date, Is_Completed, FormData]);

  useEffect(() => {
    if (Is_Expanded && task?.Assignee) {
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: { Assignee: task?.Assignee },
        },
      });
      updateValueForm(formRef, {
        Priority,
        Assignee: task?.Assignee?.Full_Name,
      });
    }
  }, [Is_Expanded]);

  useEffect(() => {
    if (Is_Expanded && FormData?.Priority) {
      onFieldUpdate(_id, "Priority", FormData?.Priority);
    }
  }, [FormData?.Priority]);

  return (
    <div className={`todo-task-item-container ${Priority.toLowerCase()} ${isOverdue ? "overdue" : ""}`}>
      <div className="todo-top-row">
        <div className="todo-left-top">
          <input
            type="checkbox"
            checked={Is_Completed}
            onChange={() => handleInputChange("Is_Completed", !taskDetails.Is_Completed)}
          />
          <input
            className={`todo-title ${taskDetails.Is_Completed ? "completed" : ""}`}
            type="text"
            value={Title}
            onChange={(e) => handleInputChange("Title", e.target.value)}
            placeholder="Enter title..."
          />
        </div>
        <div className="todo-right-top">
          <div className="date-and-assignee">
            <span className="due-label">{Due_Date ? new Date(Due_Date).toLocaleDateString() : "Set due date"}</span>
            <span className="assignee-name">{assigneeName}</span>
          </div>
          <button className="expand-button" onClick={() => onToggleExpand(_id)}>
            {Is_Expanded ? "▲" : "▼"}
          </button>
        </div>
      </div>

      {Is_Expanded && (
        <div className="todo-content">
          <div className="todo-left-col">
            <label>Notes</label>
            <textarea rows={3} value={taskDetails.Notes} onChange={(e) => handleInputChange("Notes", e.target.value)} />
          </div>
          <div className="todo-right-col">
            <div className="due-row">
              <label>Due Date</label>
              <div className="due-actions">
                <button onClick={setToday}>Today</button>
                <button onClick={setTomorrow}>Tomorrow</button>
                <input
                  type="date"
                  value={taskDetails.Due_Date || ""}
                  onChange={(e) => handleInputChange("Due_Date", e.target.value)}
                  min={today}
                />
              </div>
            </div>
            <div className="formContainer">
              {Task_Inputs.map((e, i) => {
                return (
                  <div key={e.id} className="FormSectionParent">
                    <div className="FormSection insidecontainer">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        onErrorsChange={() => {}}
                        TypeOfPortal={"Edit"}
                        formkey={Form_Key}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                      />
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="BUTTON_BOX">
              <Button name="save-btn" text="Save" loadingState={updateLoading} action={handleSave} />

              <Button name="delete-btn" text="Delete" loadingState={deleteLoading} action={() => onDelete(_id)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditableTask;
